import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo';

import FormHttpFileBtn from '../../FormHttpFileBtn.jsx';

const BtnVideo = ({
  editor,
  fileUploadUrl,
}) => {
  const [selection, setSelection] = useState(0);

  return (
    <span onClick={() => {
      const { index = 0 } = editor.getSelection() || {};

      setSelection(index);
    }}>
      <FormHttpFileBtn
        onSuccess={(res) => {
          editor.insertEmbed(
            selection,
            'video',
            res.data.url,
            'user',
          );
        }}
        api={{ url: fileUploadUrl }}
        fileOpts={{ accept: '.mp4' }}
      >
        <FA icon={faVideo} size="xs" />
      </FormHttpFileBtn>
    </span>
  );
};

export default BtnVideo;
